import React, { Component } from 'react'
import { SvgClient } from '../Svg'
/**
 * 用户中心组件
 */
class UserApp extends Component {
    static defaultProps = {
      data: [{
        url: '//iku.youku.com/channelinstall/ywebtop1',
        img: '//r1.ykimg.com/05100000585A30CB67BC3D2037022435',
        title: 'PC客户端',
        text: '免费畅享1080P',
        className: 'g-nav-iku'
      },
      {
        url: '//mobile.youku.com/index/wireless',
        img: '//r1.ykimg.com/0510000058D0FEA1ADC0AE058F099020',
        title: '优酷移动APP',
        text: '全网独播尽在手中',
        className: 'g-nav-app'
      },
      {
        url: '//pd.youku.com/CIBN',
        img: '',
        title: '优酷TV版',
        text: 'CIBN酷喵影视智能电视App',
        className: 'g-nav-tv'
      }],
      iconData: {
        url: '//pd.youku.com/',
        title: '客户端',
        className: 'ico-app'
      }
    }
    constructor (props) {
      super(props)
      this.state = {
        hoverClass: ''
      }
    }
    handleMouseEnter (e) {
      this.setState({
        hoverClass: 'dropdown-open'
      })
    }

    handleMouseLeave () {
      this.setState({
        hoverClass: ''
      })
    }
    render () {
      return (
        <div className='u-app'
          onMouseEnter={this.handleMouseEnter.bind(this)}
          onMouseLeave={this.handleMouseLeave.bind(this)}>
          <div className={`dropdown ${this.state.hoverClass}`}>
            <div className='handle'>
              <a href={this.props.iconData.url} target='_blank' rel='noopener noreferrer'>
                <SvgClient /><br />{this.props.iconData.title}</a>
            </div>
            <div className='panel'>
              <i className='arrow' />
              <div className='content'>
                <div className='g-nav-app-intro'>
                  {this.props.data.map((item, i) => {
                    return (
                      <a href={item.url} target='_blank' rel='noopener noreferrer' className={item.className} key={i}>
                        { item.img ? <img src={item.img} width='64' alt={item.title} /> : ''}
                        <h3>{item.title}</h3>
                        <span>{item.text}</span>
                      </a>)
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
}
export default UserApp
